export default __webpack_public_path__ + "static/braiding-c929853770d861224da719b96efe2f89.png";